// Public page where a user requests a password-reset email.
// URL: /forgot-password
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './AuthPages.css';

const API_BASE = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

export default function ForgotPassword() {
  const [restaurantCode, setRestaurantCode] = useState('');
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [done, setDone] = useState(false);
  const [error, setError] = useState('');

  async function submit(e) {
    e.preventDefault();
    if (!restaurantCode.trim() || !email.trim()) {
      setError('Please enter both your restaurant code and email.');
      return;
    }
    setLoading(true); setError('');
    try {
      const res = await fetch(`${API_BASE}/auth/forgot-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          restaurant_code: restaurantCode.trim().toLowerCase(),
          email: email.trim().toLowerCase(),
        }),
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data.error || 'Could not process the request');
      setDone(true);
    } catch (e) { setError(e.message); }
    setLoading(false);
  }

  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="auth-logo">VP</div>
        <h1 className="auth-title">Reset your password</h1>
        <p className="auth-sub">Enter your restaurant code and email — we'll send you a secure link to set a new password.</p>

        {done ? (
          <>
            <div className="auth-note">
              <div className="auth-note-strong">Check your email.</div>
              <div className="auth-note-muted">
                If <strong>{email}</strong> is registered for this restaurant, a password reset link is on its way. It expires in 30 minutes.
              </div>
              <div className="auth-note-fine">
                Didn't get it? Check your spam folder, then try again with the exact email on file.
              </div>
            </div>
            <div className="auth-foot"><Link to="/login">← Back to sign in</Link></div>
          </>
        ) : (
          <form onSubmit={submit} noValidate>
            <div className="auth-field">
              <label className="auth-label">Restaurant code</label>
              <input
                className="auth-input"
                value={restaurantCode}
                onChange={e => setRestaurantCode(e.target.value)}
                placeholder="e.g. himalayan"
                autoCapitalize="none"
                autoCorrect="off"
                autoComplete="off"
                autoFocus
              />
            </div>

            <div className="auth-field">
              <label className="auth-label">Email</label>
              <input
                className="auth-input"
                type="email"
                inputMode="email"
                value={email}
                onChange={e => setEmail(e.target.value)}
                placeholder="name@example.com"
                autoCapitalize="none"
                autoCorrect="off"
                autoComplete="email"
              />
            </div>

            {error && <div className="auth-error">{error}</div>}

            <button type="submit" className="auth-btn" disabled={loading}>
              {loading ? (<><span className="auth-spinner" aria-hidden="true" /><span>Sending…</span></>) : <span>Send reset link</span>}
            </button>

            <div className="auth-foot"><Link to="/login">← Back to sign in</Link></div>
          </form>
        )}
      </div>
    </div>
  );
}
